import React from 'react';

const ErrorConnection: React.FC = () => (
	<svg width="100" height="101" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clipPath="url(#clip0_5468_148435)">
			<path
				d="M50 100.5C77.6142 100.5 100 78.1142 100 50.5C100 22.8858 77.6142 0.5 50 0.5C22.3858 0.5 0 22.8858 0 50.5C0 78.1142 22.3858 100.5 50 100.5Z"
				fill="#BFBFBF"
			/>
			<path
				d="M38 26.5H44V34.5H38V26.5ZM56 26.5H62V34.5H56V26.5ZM26 34.5H74V37.5C74 38.8261 73.4732 40.0979 72.5355 41.0355C71.5979 41.9732 70.3261 42.5 69 42.5H31C29.6739 42.5 28.4021 41.9732 27.4645 41.0355C26.5268 40.0979 26 38.8261 26 37.5V34.5ZM50.667 14.8V8.5L46 16.2H49.333V22.5L54 14.8H50.667ZM41.333 19.167L40.667 16.5L44 19.167L42.667 19.833L43.333 22.5L40 19.833L41.333 19.167ZM58.667 19.167L59.333 16.5L56 19.167L57.333 19.833L56.667 22.5L60 19.833L58.667 19.167Z"
				fill="white"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M50 73.5C50.2652 73.5 50.5196 73.6054 50.7071 73.7929C50.8946 73.9804 51 74.2348 51 74.5V79.5C51 79.7652 50.8946 80.0196 50.7071 80.2071C50.5196 80.3946 50.2652 80.5 50 80.5C49.7348 80.5 49.4804 80.3946 49.2929 80.2071C49.1054 80.0196 49 79.7652 49 79.5V74.5C49 74.2348 49.1054 73.9804 49.2929 73.7929C49.4804 73.6054 49.7348 73.5 50 73.5Z"
				fill="white"
			/>
			<path d="M30 44.5H70V56.5C70 67.546 61.046 76.5 50 76.5C38.954 76.5 30 67.546 30 56.5V44.5Z" fill="white" />
			<path
				d="M56 60.5C56 61.2879 55.8448 62.0681 55.5433 62.7961C55.2417 63.5241 54.7998 64.1855 54.2426 64.7426C53.6855 65.2998 53.0241 65.7417 52.2961 66.0433C51.5681 66.3448 50.7879 66.5 50 66.5C49.2121 66.5 48.4319 66.3448 47.7039 66.0433C46.9759 65.7417 46.3145 65.2998 45.7574 64.7426C45.2002 64.1855 44.7583 63.5241 44.4567 62.7961C44.1552 62.0681 44 61.2879 44 60.5C44 58.9087 44.6321 57.3826 45.7574 56.2574C46.8826 55.1321 48.4087 54.5 50 54.5C51.5913 54.5 53.1174 55.1321 54.2426 56.2574C55.3679 57.3826 56 58.9087 56 60.5Z"
				fill="#BFBFBF"
			/>
		</g>
		<defs>
			<clipPath id="clip0_5468_148435">
				<rect width="100" height="100" fill="white" transform="translate(0 0.5)" />
			</clipPath>
		</defs>
	</svg>
);

export default ErrorConnection;
